<template>
    <div class="flex bg-white">
        <div class="flex flex-col w-8"
            :class="position == 'top' ? 'justify-end bg-gray-400' : 'justify-start bg-gray-300'"
            :style="{ minHeight: '110px' }"
        >
            <span class="transform -rotate-90 block font-medium pl-4 text-xs lg:text-sm"
                :class="position == 'top' ? 'pl-4 text-gray-800' : 'text-rtl pr-4 text-gray-700'"
            >
                {{ heading }}
            </span>
        </div>

        <div class="flex flex-1 px-4 sm:px-6"
            :class="position == 'top' ? 'items-end pt-8' : 'items-start pb-8'"
        >
            <div v-for="(visual_type, index) in visual_types"
                class="block relative"
                :style="{
                    width: ((visual_type.value / total) * 100) + '%',
                }"
            >
                <div class="absolute left-0 w-full text-center text-2xs sm:text-xs font-medium"
                    :class="position == 'top' ? 'top-0 -mt-3 sm:-mt-5' : 'bottom-0 -mb-3 sm:-mb-5'"
                >
                    <span class="flex justify-center align-center">
                        {{ visual_type.value && shouldShow(index) ? visual_type.title : '' }}
                    </span>
                </div>

                <div :style="{
                        backgroundColor: shouldShow(index) ? visual_type.color : 'transparent',
                        height: '0',
                        paddingTop: shouldShow(index) ? '100%' : '0',
                    }"
                >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        position: {},
        heading: {},
        visual_types: {},
        total: {},
    },

    methods: {
        shouldShow(index) {
            return (this.position == 'top' && ! this.isOdd(index))
                || (this.position == 'bottom' && this.isOdd(index));
        },
        isOdd(index) {
            return index % 2;
        },
    },
}
</script>
